import React from 'react';

function Typography() {
  return (
    <div className="paper">
      <div className="styleguide__title">Typography</div>
      <div className="styleguide__typography">
        <h1>h1. A few miles south of Soledad,</h1>
        <h2>h2. the Salinas River drops in close to</h2>
        <h3>h3. the hillside bank and runs deep and green.</h3>
        <h4>h4. The water is warm too, for it has slipped twinkling over</h4>
        <h5>h5. the yellow sands in the sunlight before reaching the narrow pool.</h5>
        <h6>
          h6. On one side of the river the golden foothill slopes curve up to the strong and rocky Gabilan Mountains.
        </h6>
        <p>
          On the sandy bank under the trees the leaves lie deep and so crisp that a lizard makes a great skittering if
          he runs among them. Rabbits come out of the brush to sit on the sand in the evening, and the damp flats are
          covered with the night <a href="/styleguide">tracks of ‘coons</a>, and with the spread pads of dogs from the
          ranches, and with the split-wedge <strong>tracks of deer</strong> that come to drink in the dark.
        </p>
        <ul>
          <li>There is a path through the willows and among the sycamores</li>
          <li>A path beaten hard by boys coming down from the ranches to swim in the deep pool</li>
          <li>And beaten hard by tramps who come wearily down from the highway in the evening</li>
          <li>In front of the low horizontal limb of a giant sycamore there is an ash pile</li>
        </ul>
      </div>
    </div>
  );
}

export default Typography;
